var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAcademic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1092",
    "data-name": "Rectangle 1092",
    width: 45.888,
    height: 30.674,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_academic",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(330.889 225.085)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1085",
    "data-name": "Rectangle 1085",
    width: 22.006,
    height: 19.111,
    transform: "translate(23.094 3.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21838",
    "data-name": "Path 21838",
    d: "M3.686,5.114.713,8.051.245,11.78v7.108l12.018.391L7.786,7.193,6.934,4.671Z",
    transform: "translate(0.547 10.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210-2",
    "data-name": "Group 210",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21839",
    "data-name": "Path 21839",
    d: "M11.623,16.172l-.468-1.395L10.8,15.871l-1.721.142L5.667,5.89a5.627,5.627,0,0,0-4.258,5.452v4.829Z",
    transform: "translate(3.139 13.124)",
    fill: "#946290"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21840",
    "data-name": "Path 21840",
    d: "M8.91,4.672l4.145.92,1.821,1.943.726,5.223v6.127H4.3L5.679,14.24Z",
    transform: "translate(9.581 10.41)",
    fill: "#946290"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21841",
    "data-name": "Path 21841",
    d: "M2.088,6.339a6.069,6.069,0,1,1,6.069,6.069A6.07,6.07,0,0,1,2.088,6.339",
    transform: "translate(4.652 0.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21842",
    "data-name": "Path 21842",
    d: "M4.412,1.627H8.444l.349.671L7.967,4.674l-2.6.155-.478-.436Z",
    transform: "translate(9.831 3.624)",
    fill: "#f1c14f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21843",
    "data-name": "Path 21843",
    d: "M2.431,1.713c.065.09,4.226,0,4.226,0L6.55,3.246,5.872,4.638l-2.77-.2L2.25,2.849Z",
    transform: "translate(5.013 3.817)",
    fill: "#f1c14f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21844",
    "data-name": "Path 21844",
    d: "M8.9,14.123a7.062,7.062,0,1,1,7.063-7.06A7.07,7.07,0,0,1,8.9,14.123m0-12.541A5.48,5.48,0,1,0,14.38,7.063,5.489,5.489,0,0,0,8.9,1.582",
    transform: "translate(4.089 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21845",
    "data-name": "Path 21845",
    d: "M25.974,20.222H0V10.845A6.426,6.426,0,0,1,6.421,4.427h1.63L12.838,18.64h.426L17.916,4.427h1.637a6.426,6.426,0,0,1,6.421,6.418ZM14.927,18.64h9.465v-7.8a4.844,4.844,0,0,0-4.839-4.836h-.491Zm-13.345,0h9.588L6.915,6.009H6.421a4.842,4.842,0,0,0-4.839,4.836Z",
    transform: "translate(0 9.864)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21846",
    "data-name": "Path 21846",
    d: "M6.741,4.726H3.519l.7,1.4-.7,4.9L5.13,12.638l1.611-1.611-.7-4.9Z",
    transform: "translate(7.841 10.53)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1086",
    "data-name": "Rectangle 1086",
    width: 3.38,
    height: 1.582,
    transform: "translate(3.36 19.84)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21847",
    "data-name": "Path 21847",
    d: "M9.394,3.6,8.342,2.869H1.63V1.3H8.836l.542.378L9.9,1.3h7.179V2.869H10.408Z",
    transform: "translate(3.633 2.89)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21848",
    "data-name": "Path 21848",
    d: "M3.286,6.152,1.849,2,3.334,1.49,4.4,4.56l2.2-.045.6-2.928L8.741,1.9,7.886,6.058Z",
    transform: "translate(4.12 3.321)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21849",
    "data-name": "Path 21849",
    d: "M9.517,6.152l-4.6-.094L4.062,1.9,5.6,1.587l.6,2.928,2.2.045L9.469,1.49,10.951,2Z",
    transform: "translate(9.05 3.321)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21850",
    "data-name": "Path 21850",
    d: "M30.649,21.657H9.792V20.088H29.08V2.256H6.839V.687H30.649Z",
    transform: "translate(15.237 1.531)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1087",
    "data-name": "Rectangle 1087",
    width: 1.569,
    height: 7.496,
    transform: "translate(29.328 22.623)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1088",
    "data-name": "Rectangle 1088",
    width: 1.57,
    height: 10.546,
    transform: "translate(35.992 23.217) rotate(-45)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1089",
    "data-name": "Rectangle 1089",
    width: 15.379,
    height: 1.569,
    transform: "translate(27.459 19.195)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21851",
    "data-name": "Path 21851",
    d: "M12.619,1.79h-.074A3.207,3.207,0,0,0,9.32,4.873c0,1.7,1.43,2.676,1.575,3.206s0,.788.391.914a9.2,9.2,0,0,0,2.6,0c.387-.126.242-.387.391-.914s1.575-1.5,1.575-3.206A3.208,3.208,0,0,0,12.619,1.79",
    transform: "translate(20.766 3.988)",
    fill: "#f1c14f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21852",
    "data-name": "Path 21852",
    d: "M13.128,10.414a6.584,6.584,0,0,1-1.54-.132,1.2,1.2,0,0,1-.849-1.14,2.074,2.074,0,0,0-.055-.313c-.019-.026-.171-.21-.281-.342a4.8,4.8,0,0,1-1.327-3.07A4,4,0,0,1,13.09,1.546h.074a4,4,0,0,1,4.013,3.871,4.782,4.782,0,0,1-1.327,3.07,3.415,3.415,0,0,0-.294.384c-.019.084-.029.187-.042.271a1.193,1.193,0,0,1-.852,1.14,6.521,6.521,0,0,1-1.533.132m-.849-1.6a12.372,12.372,0,0,0,1.695,0,3.672,3.672,0,0,1,.084-.407,2.663,2.663,0,0,1,.578-.917,3.308,3.308,0,0,0,.972-2.076,2.436,2.436,0,0,0-2.444-2.3H13.09a2.433,2.433,0,0,0-2.44,2.3,3.3,3.3,0,0,0,.968,2.076,2.552,2.552,0,0,1,.578.92,3.017,3.017,0,0,1,.084.4",
    transform: "translate(20.225 3.445)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1090",
    "data-name": "Rectangle 1090",
    width: 4.471,
    height: 1.569,
    transform: "translate(31.116 14.239)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1091",
    "data-name": "Rectangle 1091",
    width: 4.471,
    height: 1.569,
    transform: "translate(31.116 16.192)",
    fill: "#404040"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAcademic);
export default __webpack_public_path__ + "static/media/ic_academic.5990d1123a4ab0693aa8580a68837dba.svg";
export { ForwardRef as ReactComponent };